<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <label class="inputLabel">广告主ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          @click="add"
        >创建</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
          width="80"
        />
        <el-table-column
          prop="account_id"
          label="广告主账户id"
          align="center"
        />
        <el-table-column
          prop="strategy_id"
          label="策略 id"
          align="center"
        />
        <el-table-column
          prop="strategy_name"
          label="策略名称"
          align="center"
        />
        <el-table-column
          prop="episode_price"
          label="单集价格"
          align="center"
          sortable="custom"
        />
        <el-table-column
          prop="min_recharge_tier"
          label="最低充值档位"
          align="center"
          sortable="custom"
          width="180"
        />
        <el-table-column
          prop="recharge_num"
          label="起充集数"
          align="center"
        />
        <el-table-column
          prop="strategy_status"
          label="策略状态"
          align="center"
        />

        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
        />
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="创建短剧售卖策略"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
    >
      <brandDialog
        ref="add"
        @submit="submit"
      />
    </el-dialog>
  </div>
</template>

<script>
import brandDialog from './components/landingPageSellStrategyDialog.vue'

import { landing_page_sell_strategy, landing_page_sell_strategyCreate } from '@/api/customer.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import detailsList from '../../customer/accountList/components/details.vue'
export default {
  name: 'LandingPageSellStrategy',
  components: {
    PaginationRight,
    brandDialog
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async submit(obj, fu) {
      await landing_page_sell_strategyCreate(obj)
      this.$message.success('创建成功')
      setTimeout(() => {
        this.getAdvertiserList()
      }, 2 * 60 * 1000)
      this.handleClose()
      fu()
    },
    handleClose() {
      this.dialogVisible = false
    },
    add(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.send(row)
      })
    },
    getAdvertiserList() {
      this.loading = true
      landing_page_sell_strategy(this.advertisersQuery).then(res => {
        console.log('res:', res)
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
        console.log(22)
      })
    },
    copy(data) {
      const newdata = data.profile_url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 120px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.url-wrapper {
  color: blue;
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
